import { render, staticRenderFns } from "./RuleItem.vue?vue&type=template&id=cddbde1c&scoped=true"
import script from "./RuleItem.vue?vue&type=script&lang=js"
export * from "./RuleItem.vue?vue&type=script&lang=js"
import style0 from "@/styles/_left_menu.scss?vue&type=style&index=0&id=cddbde1c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cddbde1c",
  null
  
)

export default component.exports